import AbTestingLayout from '@/views/AbTesting/AbTestingLayout.vue';

export default [
  {
    path: 'ab-testing',
    name: 'ab-testing',
    component: AbTestingLayout,
    meta: {
      title: 'A/B Testing',
      permission: 'ab-testing',
    },
  },
];
